import React from 'react';
import ReactDOM from 'react-dom';
import { Provider  } from 'react-redux'

import App from './routes/App';
import './i18n';
import store from './store'


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);
